<div class="card card-box">
  <div class="card-header" *ngIf="isHeader">
    <ng-content select="[title]"></ng-content>
  </div>
  <ng-content select="[action-bar]"></ng-content>
  <div class="card-body" *ngIf="containBody">
    <ng-content></ng-content>
  </div>
</div>
